import { apiClient } from "../api/apiClient";

import {ApiResponse, Tag,CreateTagRequest,UpdateTagRequest} from "../interfaces/Tags";

// ======================================
// TAG SERVICE
// ======================================

export const TagService = {

  // ======================================
  // GET ALL
  // ======================================

getAll: async (): Promise<Tag[]> => {

  const response =
    await apiClient.get<
      ApiResponse<Tag[]>
    >(
      "/Tag/GetAll"
    );

  const result =
    response.data;

  console.log(
    "Tag Data List:",
    result.dataList
  );

  if (!result.isSuccess) {

    throw new Error(
      result.message
    );
  }

  return result.dataList ?? [];
},

  // ======================================
  // GET BY ID
  // ======================================

  getById: async (
    id: number
  ): Promise<Tag> => {

    const response =
      await apiClient.get<
        ApiResponse<Tag>
      >(
        `/Tag/${id}`
      );

    const result =
      response.data;

    if (!result.isSuccess) {

      throw new Error(
        result.message
      );
    }

    if (!result.data) {

      throw new Error(
        "Tag not found"
      );
    }

    return result.data;
  },

  // ======================================
  // CREATE
  // ======================================

  create: async (
    payload: CreateTagRequest
  ) => {

    const formData =
      new FormData();

    formData.append(
      "TagName",
      payload.tagName
    );

    // SEO

    formData.append(
      "MetaTitle",
      payload.metaTitle || ""
    );

    formData.append(
      "MetaDescription",
      payload.metaDescription || ""
    );

    formData.append(
      "MetaKeywords",
      payload.metaKeywords || ""
    );

    formData.append(
      "CanonicalUrl",
      payload.canonicalUrl || ""
    );

    // OG

    formData.append(
      "OgTitle",
      payload.ogTitle || ""
    );

    formData.append(
      "OgDescription",
      payload.ogDescription || ""
    );

    // SCHEMA

    formData.append(
      "SchemaMarkup",
      payload.schemaMarkup || ""
    );

    const response =
      await apiClient.post(
        "/Tag/Create",
        formData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data"
          }
        }
      );

    return response.data;
  },

  // ======================================
  // UPDATE
  // ======================================

  update: async (
    payload: UpdateTagRequest
  ) => {

    const formData =
      new FormData();

    formData.append(
      "TagID",
      payload.tagID.toString()
    );

    formData.append(
      "TagName",
      payload.tagName
    );

    // SEO

    formData.append(
      "MetaTitle",
      payload.metaTitle || ""
    );

    formData.append(
      "MetaDescription",
      payload.metaDescription || ""
    );

    formData.append(
      "MetaKeywords",
      payload.metaKeywords || ""
    );

    formData.append(
      "CanonicalUrl",
      payload.canonicalUrl || ""
    );

    // OG

    formData.append(
      "OgTitle",
      payload.ogTitle || ""
    );

    formData.append(
      "OgDescription",
      payload.ogDescription || ""
    );

    // SCHEMA

    formData.append(
      "SchemaMarkup",
      payload.schemaMarkup || ""
    );

    const response =
      await apiClient.put(
        "/Tag/Update",
        formData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data"
          }
        }
      );

    return response.data;
  },

  // ======================================
  // DELETE
  // ======================================

  delete: async (
    id: number
  ) => {

    const response =
      await apiClient.delete(
        `/Tag/${id}`
      );

    return response.data;
  }
};